import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaCheckDouble,
  FaHandshake,
  FaChartPie,
  FaUserGraduate,
  FaArrowRight,
} from 'react-icons/fa';
import { otherServices } from '../data/servicesData';
import './ServiceCrossNav.css';

const ICONS = {
  'check-double': <FaCheckDouble />,
  handshake: <FaHandshake />,
  'chart-pie': <FaChartPie />,
  'user-graduate': <FaUserGraduate />,
};

const ServiceCrossNav = ({ currentSlug }) => {
  const others = otherServices(currentSlug);

  return (
    <section className="cross-nav-section">
      <div className="container">
        <div className="cross-nav-header">
          <h5>NOS AUTRES SERVICES</h5>
          <h3>Découvrir l'ensemble de notre offre</h3>
        </div>

        <div className="cross-nav-grid">
          {others.map((service) => (
            <Link
              key={service.slug}
              to={`/services/${service.slug}`}
              className="cross-nav-card"
            >
              <div className="cross-nav-icon">{ICONS[service.iconKey]}</div>
              <span className="cross-nav-eyebrow">{service.subtitle}</span>
              <h4>{service.title}</h4>
              <span className="cross-nav-link">
                Découvrir <FaArrowRight />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCrossNav;
